<ion-button (click)="presentPopover($event)">
    <ion-icon name="options-outline" style="color: var(--ion-title-color);"></ion-icon>
</ion-button>
